<template>
    <div class="filtering-bar" v-if="beds">
        <div  class="search-icon">
            <svg id="f037401e-a894-40a7-b860-30eb929d66b8" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><path d="M61.72,61.8l-9.21-9.2A18.49,18.49,0,1,0,51.07,54l9.23,9.23ZM22.5,40A16.5,16.5,0,1,1,39,56.5,16.52,16.52,0,0,1,22.5,40Z"/></svg>

        </div>
        <ul class="list-filters">
            <li class="borders">
                <a href=""
                   @click.prevent.stop="showSubmenu"
                   title="Bedrooms">
                    <span class="name">Bedrooms</span>
                    <svg id="fc7f5418-6304-4224-b4ad-b4d7d4d77161" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><polygon points="21.56 32.44 23.33 30.67 43.44 50.79 63.56 30.67 65.33 32.44 43.44 54.33 21.56 32.44"/></svg>
                </a>

                <div class="sub-menu-filter bedroom-filter" v-if="dropdown">
                    <div class="wrap-bedroom-filter">
                        <h4>Bedrooms
                            <small>(select multiple)</small>
                        </h4>

                        <div class="checkbox-item" v-for="filter in beds" :key="filter.value">
                            <label><input class="primary-background-color-checked" type="radio" v-model="bedroomValue" :value="filter.value"
                                          @click="validateChecks(filter)"> {{filter.label}}</label>
                        </div>

                    </div>
                </div>

            </li>
        </ul>
    </div>
</template>

<script>
    import {EventBus} from "../../utils/eventBus";
    import _size from 'lodash/size';
    import _isNull from 'lodash/isNull';
    import _isUndefined from 'lodash/isUndefined';
    import _isArray from 'lodash/isArray';
    import _filter from 'lodash/filter';
    import _reject from 'lodash/reject';
    import _isEqual from 'lodash/isEqual';

    export default {
        name: "FilterProperty",
        data(){
            return {
                dropdown: false,
                bedroomValue: [],
            }
        },
        props: {
            filters: Object,
            microsite: {
                type: Boolean,
                default: false,
            }
        },
        mounted(){
            this.bedroomValue = this.ensureArray(this.$route.query.beds) || [];
        },
        computed: {
            beds(){
                return this.filters && this.filters.bedrooms;
            },
            queryParams() {
                const beds = this.bedroomValue.length && this.bedroomValue;

                return {
                    ...(beds && {beds}),
                }
            },
        },
        methods: {
            showSubmenu(){
                this.dropdown = !this.dropdown;
            },
            ensureArray(value, includingNullish = false) {
                if(_isArray(value)) return value;

                if(!includingNullish && (_isNull(value) || _isUndefined(value))) return value;

                return [value];
            },
            validateChecks(filter) {
                // const method = filter.value === 'all' ? _filter : _reject;
                // const bedroomValue = method(this.bedroomValue, item => item.value === 'all');

                if (!this.microsite) {
                    this.$nextTick(() => {
                        EventBus.zekiFilter = filter.value;
                        this.$router.push({path: '/floorplans'});
                    });
                } else {
                    this.$nextTick(() => {
                        this.showSubmenu();
                        this.$emit('clicked', filter.value);
                    });
                }
            },
        }
    }
</script>

<style lang="scss" scoped>


    .filtering-bar {
        background-color: rgba(#fff, 0.5);
        box-shadow: 0 2px 8px rgba(#000, .15);
        margin: 0 10px;
        border-radius: 17.5px;
        height: 35px;
        display: flex;
        align-items: center;

        .search-icon{
            svg{
                width: 27px;
                position: relative;
                top: 3px;
                left: 5px;
                fill: $color2;
                stroke: $color2;
            }
        }

        .reset-icon{
            padding: 0 8px;
            border-left: 1px solid lighten($color2, 20%);
            svg{
                width: 25px;
                fill: $color2;
                stroke: $color2;
                background-color: lighten($color2, 20%);
                border-radius: 50%;
                position: relative;
                top: 4px;
            }
        }


        .list-filters {
            list-style: none;
            margin: 0;
            padding: 0 0 0 20px;
            max-width: calc(100% - 27px);

            li {
                display: inline-block;
                vertical-align: middle;
                list-style: none;
                margin: 0 0 0 5px;
                padding: 0;
                position: relative;
                min-width: 145px;

                @media (max-width: 405px){
                    min-width: auto;
                    max-width: calc(100% - 5px);
                }

                > a {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 7px 10px 7px 0;
                    color: $color1;
                    text-decoration: none !important;
                    font-size: 14px;
                    font-weight: 400;

                    svg{
                        width: 15px;
                        fill: $color1;
                        stroke: $color1;
                    }
                }

                span.name, .svg-icon {
                    display: inline-block;
                    vertical-align: middle;
                }

                span.name {
                    width: 250px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .svg-icon {
                    height: auto;

                    /deep/ svg {
                        width: 15px;
                    }
                }

                .sub-menu-filter {
                    position: absolute;
                    background-color: #fff;
                    padding: 10px 0;
                    top: 43px;
                    width: 100%;
                    left: 0;
                    box-shadow: 0 2px 8px rgba(#000, .15);
                    z-index: 20;

                    &.bedroom-filter {
                        width: calc(100% + 30px);
                        left: -40px;

                        h4 {
                            font-size: 15px;
                            margin-bottom: 0;
                            margin-top: 0;
                            font-weight: 600;
                            display: none;

                            small {
                                font-size: 10px;
                                font-weight: 300;
                                letter-spacing: 1px;
                            }
                        }

                        label {
                            font-weight: 400;
                            cursor: pointer;
                            font-size: 14px;
                            display: block;
                            padding: 0 20px;

                            @media (max-width: 992px){
                                padding: 10px 20px;
                            }

                            input {
                                margin-right: 10px;
                                -webkit-appearance: none;
                                -moz-appearance: none;
                                appearance: none;
                                box-shadow: none;
                                width: 15px;
                                height: 15px;
                                border: 1px solid lighten($color1, 40%);
                                margin-top: 0;
                                position: relative;
                                top: 6px;
                                cursor: pointer;
                                outline: 0 !important;
                                display: none;

                                &:checked {
                                    background: url('data:image/svg+xml;charset=UTF-8,<svg fill="#fff" id="880378c8-6192-4e4a-923d-b0c87d049565" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><polygon points="58.58 25.95 56.4 24.73 38.2 57.61 23.27 49.2 22.04 51.38 39.15 61.01 58.58 25.95"/></svg>') no-repeat center center lighten($color1, 40%);
                                }
                            }

                            &:hover{
                                background-color: lighten($color2, 20%);
                            }
                        }

                        .checkbox-item {
                            margin: 7px 0;
                        }

                    }
                }
            }
        }
    }

</style>